module.exports = __webpack_public_path__ + "static/media/pointerActive.0d3b2719.png";